/**
 * @description: 我的寄件地址
 * @author: 51fan
 */
<template>
  <div class="addressManageContent main-wrap">
       <div class="main-top">
            <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont iconxinzeng">{{$lang('新增寄件地址')}}</el-button>
            <div class="searchParam">
                <div class="searchParamInput">
                    <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width:336px !important"></el-input>
                </div>
                <el-button type="primary"  @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{$lang("查询")}}</el-button>
                <el-button type="primary"  @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{$lang("清空")}}</el-button>
                <!--<el-button type="primary" class="addAddress" @click="rowAdd"><i class="iconfont iconxinzeng"></i> 新增寄件地址</el-button> -->
            </div>
       </div>
       <div class="main-table">
            <JmsTableScroll
            :option="listOpt"
            :data="tableList"
            :page="page"
            :table-loading="loading"
            @row-edit="rowEdit"
            @row-del="rowDel"
            @size-change="sizeChange"
            @select-change="selectionChange"
            @current-change="currentChange">
              <template slot="isDefault" slot-scope="data">
                    <el-switch
                                v-model="data.row.isDefault"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                :active-value="1"
                                :inactive-value="2"
                                disabled>
                    </el-switch>
                </template>
            </JmsTableScroll>
       </div>
    <!-- 编辑地址 -->
    <el-dialog :title="diglogTitle" :visible.sync="editDialogVisible" width="1020px" @close="handleClose" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form class="el-form-edit" ref="tableForm"  :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <!-- <el-form-item label="地址识别" class="item-col-4">
          <el-input v-model="analysisAddress" :autosize="{minRows: 5 }"  type="textarea" placeholder="粘贴或者输入整段地址，点击“识别”自动拆分姓名、电话和地址。例如：李小兔，13800138000，上海市黄浦区某某大厦…">
          </el-input>
          <div class="oper">
            <span class="red" @click="discern(0)">智能识别</span>
            <span @click="discern(1)">清空</span>
          </div>
        </el-form-item> -->
        <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name"  :minlength="1"  :maxlength="30"  :placeholder="$lang('请输入姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('手机')" prop="mobile"  class="myDetailItem formPhone">
          <!-- <el-input v-model="rowData.mobile" :maxlength='15' :placeholder="$lang('请输入手机')"></el-input> -->
          <BasePhoneInput :maxlength="16" :value="phoneVal" v-model="rowData.mobile"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('公司')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :placeholder="$lang('请输入公司')"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="provinceSearch" :initAddressData="initAddressData" :showLevel="3" v-model="rowData.province"> </BaseAddress>
        </el-form-item> -->
        <!-- <el-form-item :label="$lang('邮编')" prop="postalCode" class="myDetailItem">
            <template slot="label"><span :title="$lang('邮编')">{{$lang('邮编')}}</span></template>
            <el-input v-model="rowData.postalCode" :placeholder="$lang('请输入邮编')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item> -->
        <el-form-item :label="$lang('邮箱')" prop="email" class="myDetailItem">
            <template slot="label"><span :title="$lang('邮箱')">{{$lang('邮箱')}}</span></template>
            <el-input v-model="rowData.email" :minlength="1" :placeholder="$lang('请输入邮箱')"  :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item :label="provinceName" prop="provinceName" class="myDetailItem">
          <el-select v-model="rowData.provinceName" filterable @change="dataProvinceChange($event)">
            <el-option
              v-for="item in provinceArray"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="cityName" prop="cityName" class="myDetailItem">
          <el-select v-model="rowData.cityName" filterable @change="dataCityChange($event)">
            <el-option
              v-for="item in cityList"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="areaName1" prop="areaName" class="myDetailItem" v-if="this.countryId === 1">
          <el-select v-model="rowData.areaName" filterable @change="dataAreaChange($event)">
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('街道')" prop="street" class="myDetailItem">
            <template slot="label"><span :title="$lang('街道')">{{$lang('街道')}}</span></template>
            <el-input v-model="rowData.street" :placeholder="$lang('请输入街道')"  :minlength="1"  :maxlength="20" />
        </el-form-item>
          <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
            <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请输入寄件人所在街道以及详细地址')"  :minlength="1"  :maxlength="200"></el-input>
          </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('寄件短地址')" prop="shortAddress">
          <template slot="label"><span :title="$lang('寄件短地址')">{{ $lang('寄件短地址') }}</span></template>
          <el-input v-model="rowData.shortAddress" :placeholder="$lang('请输入寄件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress(rowData)" />
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('寄件辅助编号')" prop="referenceNumber">
          <template slot="label"><span :title="$lang('寄件辅助编号')">{{ $lang('寄件辅助编号') }}</span></template>
          <el-input v-model="rowData.referenceNumber" :placeholder="$lang('请输入寄件辅助编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('寄件建筑物编号')" prop="buildingNumber">
          <template slot="label"><span :title="$lang('寄件建筑物编号')">{{ $lang('寄件建筑物编号') }}</span></template>
          <el-input v-model="rowData.buildingNumber" :placeholder="$lang('请输入寄件建筑物编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <el-form-item :label="$lang('设为默认')" prop="isDefault">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd" :active-value="1" :inactive-value="2"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose('tableForm')">取 消</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="handleSubmit('tableForm')" class="h40 h104">{{$lang('保存')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
// import JmsTableScroll from '@/components/jms-widget/jms-table'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin'
import { addAddress, reqAddressList, updateAddress, delAddress, judgeShortAddress } from '@/api/module/customer'
import { RULES, checkAddressFormat, phoneAndMobile, isNull } from '@utils/rules'
import * as Api from '@api/base/public'

export default {
  name: 'MailingAddress',
  components: {
    JmsTableScroll,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      diglogTitle: this.$lang('新增寄件地址'),
      analysisAddress: '',
      searchParam: '',
      value: '',
      phoneVal: '',
      rowData: {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        street: '',
        detailedAddress: '',
        isDefault: 2, // 是否设置为默认地址 1设置默认地址 2 不设置
        type: 1, // 1 寄件 2收件
        id: '',
        // postalCode: '',
        email: '',
        shortAddress: '',
        buildingNumber: '',
        referenceNumber: ''
      },
      provinceArray: [], // 酋长国
      cityList: [], // 区域
      areaList: [],
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      tableList: [],
      isRowDetailUrl: false,
      rules: {
        name: [RULES.required, { validator: isNull }],
        mobile: [RULES.requiredTrim, { validator: phoneAndMobile }],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.requiredTrim, { validator: checkAddressFormat }],
        provinceName: [RULES.requiredSelect],
        cityName: [RULES.requiredSelect],
        shortAddress: [RULES.codeNumber],
        buildingNumber: [RULES.twenty],
        referenceNumber: [RULES.twenty],
        // areaName: [RULES.requiredSelect],
        // areaName: [RULES.required, { validator: checkAddressFormat }],
      },
      delTitObj: {
        title: this.$lang('删除寄件地址'),
        subTitle: this.$lang('你确定要删除该寄件地址吗？'),
        threeTitle: '',
      },
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      provinceName: this.$lang('省份'),
      cityName: this.$lang('城市'),
      areaName1: this.$lang('区域'),
      areaName: this.$lang('寄件区域'),
      provinceName1: this.$lang('省份'),
      cityName1: this.$lang('寄件城市'),
    }
  },
  computed: {
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    listOpt() {
      const that = this
      return {
        fixHeight: 90,
        border: true,
        selection: false,
        menu: true,
        menuWidth: 150,
        // rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '寄件人姓名',
            prop: 'name',
          },
          // {
          //   label: '电话区号',
          //   prop: 'areaCode',
          //   formatter: (row, value, label, column) => {
          //     return '966'
          //   },
          // },
          {
            label: '寄件人手机', //  扫描员
            prop: 'mobile',
          },
          {
            // label: '省份',
            label: that.provinceName1,
            prop: 'provinceName',
          },
          {
            // label: '寄件城市',
            label: that.cityName1,
            prop: 'cityName',
          },
          {
            label: that.areaName,
            prop: 'areaName',
            show: this.countryId === 1
          },
          {
            label: '寄件街道',
            prop: 'street',
          },
          {
            label: '寄件详细地址',
            prop: 'detailedAddress',
          },
          {
            label: '寄件短地址',
            prop: 'shortAddress',
          },
          {
            label: '寄件辅助编号',
            prop: 'referenceNumber',
          },
          {
            label: '寄件建筑物编号',
            prop: 'buildingNumber',
          },
          {
            label: '邮箱',
            prop: 'email',
          },
          {
            label: '寄件人公司',
            prop: 'companyName',
          },
          // {
          //   label: '邮编',
          //   prop: 'postalCode',
          // },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green" style="color: #00da00;"></i> ' + '是',
            //     2: '<i class="dot oragin" style="color: #ffa111"></i> ' + '否',
            //   }
            //   return map[row.isDefault]
            // },
          },
          {
            label: '创建人',
            prop: 'userName',
          },
        ],
      }
    },
  },
  watch: {
    'countryCode': {
      handler(val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.provinceName = that.$lang('酋长国')
          that.cityName = that.$lang('区域')
          that.provinceName1 = that.$lang('寄件酋长国')
          that.cityName1 = that.$lang('寄件区域')
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getProList()
  },

  methods: {
    async judgeShortAddress(rowData) {
      if (!rowData?.shortAddress) {
        rowData.shortAddress = ''
        return
      }
      const regex = /^[A-Za-z]{4}\d{4}$/
      if (!regex.test(rowData.shortAddress)) {
        rowData.shortAddress = ''
        this.$message.error(this.$lang('不符合短地址规则'))
        return
      }
      try {
        const { code, data } = await judgeShortAddress({
          shortAddress: rowData.shortAddress
        })
        if (code !== RESPONSE_SUCCESS || data !== true) {
          rowData.shortAddress = ''
          this.$message.error(this.$lang('未查询到短地址信息,请输入正确的短地址'))
        }
      } catch (error) {
        rowData.shortAddress = ''
      }
    },
    getParams() {
      return {
        type: 1,
        keyword: this.searchParam,
      }
    },
    // 获取酋长国数据
    async getProList() {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
      } else {
        this.$message.error(msg)
      }
    },

    // 选中获取值
    dataProvinceChange(value) {
      this.getCityList(value)
    },

    // 获取城市数据
    async getCityList(parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.rowData.provinceId = parentId
        this.rowData.cityId = data[0].id
        this.rowData.cityName = data[0].nativeName
        let obj = {}
        obj = this.provinceArray.find((item) => {
          return item.id === parentId
        })
        this.rowData.provinceName = obj.nativeName
      } else {
        this.$message.error(msg)
      }
    },
    // 获取区域数据
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.rowData.areaId = data[0].id
        this.rowData.areaName = data[0].nativeName
      } else {
        this.$message.error(msg)
      }
    },
    // 选中城市
    dataCityChange(value) {
      console.log(value)
      this.rowData.cityId = value
      const obj = this.cityList.find((item) => {
        return item.id === value
      })
      this.rowData.cityName = obj.nativeName
      if (this.countryId === 1) { // 1- 沙特  2-阿联酋 (沙特显示区域，阿联酋不显示)
        this.getAreaList(value)
      }
    },
    // 选中区域
    dataAreaChange(value) {
      this.rowData.areaId = value
      const obj = this.areaList.find((item) => {
        return item.id === value
      })
      this.rowData.areaName = obj.nativeName
    },
    beforeSubmit() {
      return { ...this.rowData, type: 1 }
    },
    // 弹窗关闭前
    beforehandleClose() {
      this.diglogTitle = this.$lang('新增寄件地址')
      this.cityList = []
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      // debugger
      this.diglogTitle = this.$lang('编辑地址')
      this.getCityInfo(row.provinceId)
      this.getAreaInfo(row.cityId)
      // const { provinceId, provinceName, cityId, cityName, areaId, areaName, isDefault } = row
      // provinceName: '',
      //   cityName: '',
      //   areaName: '',
      // this.initAddressData.defaultData.provinceId = ''
      // this.initAddressData.defaultData.provinceName = ''
      // this.initAddressData.defaultData.cityId = ''
      // this.initAddressData.defaultData.cityName = ''
      // this.initAddressData.defaultData.areaId = ''
      // this.initAddressData.defaultData.areaName = ''

      // const defaultData = { provinceId, provinceName, cityId, cityName, areaId, areaName }
      // this.$nextTick(function () {
      //   this.$set(this.initAddressData, 'defaultData', defaultData)
      // })
      return { ...row, type: 1 }
    },

    // 查询数据
    async getCityInfo (provinceId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 查询数据
    async getAreaInfo (provinceId) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    // 重置表单项
    clearFormItem () {
      this.rowData = {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        street: '',
        detailedAddress: '',
        isDefault: 2,
        type: 1,
        id: '',
        // postalCode: '',
        email: '',
        shortAddress: '',
        buildingNumber: '',
        referenceNumber: ''
      }
      // this.initAddressData.defaultData.provinceId = ''
      // this.initAddressData.defaultData.provinceName = ''
      // this.initAddressData.defaultData.cityId = ''
      // this.initAddressData.defaultData.cityName = ''
      // this.initAddressData.defaultData.areaId = ''
      // this.initAddressData.defaultData.areaName = ''
      // this.$refs.provinceSearch.clearInput()
      this.$refs['tableForm'].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.formPhone {
  ::v-deep .el-form-item__label{
    width: 220px !important;
  }
}
.formPhone {
  ::v-deep .el-form-item__content{
    width: 220px !important;
  }
}
.addressManageContent {
  .main-top{
       padding:16px 24px;
  }
  .main-table{
     padding: 12px 24px;
    background: #edeef3;
    flex: 1;
        display: flex;
        flex-direction: column;
  }
  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }
  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
        .el-input{
             width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.oper{
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;
  .red{
    color: red;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.addressManageContent{
    .el-table__fixed, .el-table__fixed-right{
        height: 705px !important;
    }
}
</style>
